module.exports = __webpack_public_path__ + "static/media/nexo.2f1eb8a8.svg";